module.exports = __webpack_public_path__ + "static/Business_benifitted-0455a2bdb01be001ed4bfb8aef64bfe6.png";